/**
 * Inbound Filter Service
 * Handles API calls for the inbound spam filter config.
 */

import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import { withBuScope } from '@/lib/business-unit-scope';
import type { ApiResponse, InboundFilterConfig, InboundFilterTicketFields, UpdateInboundFilterDto } from '@/types';

export const inboundFilterService = {
  /**
   * Get the current account's inbound filter config.
   * Returns default { enabled: false, blockedDomains: [], blockedEmails: [] } if none exists.
   */
  async getInboundFilters(scope?: { bu_id?: string }): Promise<InboundFilterConfig> {
    const response = await api.get<ApiResponse<InboundFilterConfig>>(API_ENDPOINTS.INBOUND_FILTERS.BASE, {
      params: scope,
    });
    return response.data.data;
  },

  /**
   * The helpdesk ticket fields auto-close can fill in. Empty unless Gorgias is connected.
   */
  async getTicketFields(scope?: { bu_id?: string }): Promise<InboundFilterTicketFields> {
    const response = await api.get<ApiResponse<InboundFilterTicketFields>>(API_ENDPOINTS.INBOUND_FILTERS.TICKET_FIELDS, {
      params: scope,
    });
    return response.data.data;
  },

  /**
   * Update the inbound filter config (partial update -- send only changed fields).
   */
  async updateInboundFilters(
    data: UpdateInboundFilterDto,
    scope?: { bu_id?: string }
  ): Promise<InboundFilterConfig> {
    const response = await api.put<ApiResponse<InboundFilterConfig>>(
      withBuScope(API_ENDPOINTS.INBOUND_FILTERS.BASE, scope ?? {}),
      data
    );
    return response.data.data;
  },
};
